// assets/free-shipping-frete.js
(function(){
  'use strict';

  const threshold = 300.00;

  // 1) utilitário: “R$ 1.234,56” → 1234.56
  function parseBRL(str) {
    return parseFloat(
      str
        .replace(/[^\d,\.]/g, '') // tira tudo que não for dígito, ponto ou vírgula
        .replace(/\./g, '')       // remove separador de milhar
        .replace(/,/g, '.')       // vírgula → ponto
    ) || 0;
  }

  // 2) utilitário: 1234.56 → “R$ 1.234,56”
  function formatBRL(num) {
    return num.toLocaleString('pt-BR', {
      style:    'currency',
      currency: 'BRL'
    });
  }

  // 3) faz o cálculo e injeta no placeholder
  function updateFreeShipping() {
    const totalEl = document.querySelector('p.totals__total-value');
    const wrapper = document.getElementById('free-shipping-simulator');
    const msgEl   = document.getElementById('free-shipping-message');
    if (!wrapper || !msgEl) return;

    const total = parseBRL(totalEl ? totalEl.textContent : '0');

    if (total === 0) {
      msgEl.innerHTML = `Frete grátis a partir de <span class="free-amount">${formatBRL(threshold)}</span>`;
    } else if (total < threshold) {
      const falta = threshold - total;
      msgEl.innerHTML = `Faltam <span class="free-amount">${formatBRL(falta)}</span> para você ganhar frete grátis`;
    } else {
      msgEl.innerHTML = `Sua compra agora tem <span class="free-amount">frete grátis</span> garantido`;
    }
  }

  // 4) dispara no load
  document.addEventListener('DOMContentLoaded', updateFreeShipping);

  // 5) MutationObservers para alterações via AJAX
  const totalsContainer = document.querySelector('.totals');
  if (totalsContainer) {
    new MutationObserver(updateFreeShipping).observe(totalsContainer, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }
  const totalValueEl = document.querySelector('p.totals__total-value');
  if (totalValueEl) {
    new MutationObserver(updateFreeShipping).observe(totalValueEl, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  // 6) eventos customizados do tema (se houver)
  ['cart:updated','cart:refresh','cart:refresh:completed','ajax:complete']
    .forEach(evt => document.addEventListener(evt, updateFreeShipping));

  // 7) polling fallback: dispara se detectar mudança no total
  let lastTotal = null;
  setInterval(() => {
    const el = document.querySelector('p.totals__total-value');
    if (!el) return;
    const current = parseBRL(el.textContent);
    if (!isNaN(current) && current !== lastTotal) {
      lastTotal = current;
      updateFreeShipping();
    }
  }, 1000);

})();
